var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterLogoDark = function SvgFooterLogoDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3593 1443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.554C0 25.928 41.842-7.714 86.417 1.538L1089.78 213.69c76.11 15.98 76.11 124.054 0 140.033L86.417 565.245C41.842 574.707 0 541.065 0 495.439V71.554Zm0 876.154c0-45.626 41.842-79.268 86.417-70.017L1089.78 1089.84c76.11 15.98 76.11 124.06 0 140.04L86.417 1441.4C41.842 1450.86 0 1417.22 0 1371.59V947.708Zm1335.15 53.402c44.58 9.47 86.42-24.807 86.42-70.013V512.47c0-45.837-41.84-79.268-86.42-70.017L334.944 651.872c-76.114 15.98-76.114 124.474 0 140.033L1335.15 1001.11Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.14 1179.61V262.039h661.27v200.798H1896.3v157.695h378.05v200.799H1896.3v157.695h410.22v200.584h-659.38Zm1578.64-917.571v917.571h-207.95l-331.58-482.122h-5.47v482.122h-249.16V262.039h211.53l326.32 480.234h7.15V262.039h249.16Zm366.9 0v917.571h-249.16V262.039h249.16Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 74.678,
    y1: 584.72,
    x2: 1210.83,
    y2: 1137.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3492CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7856FF"
  })))));
};
export default SvgFooterLogoDark;